import { render, staticRenderFns } from "./social_create_post.vue?vue&type=template&id=1155c1b2&scoped=true&"
import script from "./social_create_post.vue?vue&type=script&lang=js&"
export * from "./social_create_post.vue?vue&type=script&lang=js&"
import style0 from "./social_create_post.vue?vue&type=style&index=0&id=1155c1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155c1b2",
  null
  
)

export default component.exports